// ==============================|| OVERRIDES - TYPOGRAPHY ||============================== //

export default function Popover() {
    return {
        MuiPopover: {
            styleOverrides: {
                paper: {
                    borderRadius: 20,
                },
            },
        },
    }
}
